// ===== frontend/src/utils/api.js (Fixed) =====
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Generic API request function
const apiRequest = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  console.log('API Request to:', url); // Debug log
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  // Don't set Content-Type for FormData
  if (options.body instanceof FormData) {
    delete defaultOptions.headers['Content-Type'];
  }

  const config = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);
    
    console.log('Response status:', response.status); // Debug log
    
    if (!response.ok) {
      let errorMessage = `HTTP error! status: ${response.status}`;
      
      try {
        const errorData = await response.json();
        errorMessage = errorData.detail || errorMessage;
      } catch (parseError) {
        // If we can't parse the error response, use the status text
        errorMessage = response.statusText || errorMessage;
      }
      
      throw new Error(errorMessage);
    }

    const result = await response.json();
    console.log('API Response:', result); // Debug log
    return result;
    
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};

// PDF Upload API
export const uploadPDF = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return apiRequest('/upload_pdf', {
    method: 'POST',
    body: formData,
  });
};

// Load recommended form
export const loadRecommendedForm = async (formId) => {
  return apiRequest(`/load_recommended_pdf/${formId}`, {
    method: 'POST',
  });
};

// Update form fields
export const updateFormFields = async (sessionId, fieldValues) => {
  return apiRequest(`/update_fields/${sessionId}`, {
    method: 'POST',
    body: JSON.stringify({ field_values: fieldValues }),
  });
};

// AI fill form
export const aiFillForm = async (sessionId, sourceText) => {
  return apiRequest(`/ai_fill/${sessionId}`, {
    method: 'POST',
    body: JSON.stringify({ source_text: sourceText }),
  });
};

// Generate filled PDF
export const generateFilledPDF = async (sessionId) => {
  return apiRequest(`/generate_pdf/${sessionId}`, {
    method: 'POST',
  });
};

// Get session data
export const getSessionData = async (sessionId) => {
  return apiRequest(`/session/${sessionId}`);
};

// Download PDF helper
export const downloadPDF = (sessionId) => {
  const url = `${API_BASE_URL}/download/${sessionId}`;
  window.open(url, '_blank');
};

// Health check
export const healthCheck = async () => {
  return apiRequest('/health');
};